import { keyframes } from "@emotion/react";
import { Box, styled, Typography } from "@mui/material";
import React from "react";

const LoadingAnimationWithText = ({ text }) => {
  // Define a keyframes animation for a pulsing effect
  const pulse = keyframes`
        0% { opacity: 0.2; }
        50% { opacity: 1; }
        100% { opacity: 0.2; }
      `;

  // Create a styled Typography component with the animation
  const ReasoningText = styled(Typography)(({ theme }) => ({
    animation: `${pulse} 1.5s ease-in-out infinite`,
    fontSize: "1rem",
    fontWeight: "normal",
    textAlign: "center",
    // Apply gradient to the text color
    background: "#003D78",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  }));
  return (
    <>
      <ReasoningText>{text}</ReasoningText>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.7,
          px: "4px",
          mt: 1,
        }}
      >
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              background: "#003D78",
              animation: "bounce 1.4s infinite",
              animationDelay: `${index * 0.2}s`,
            }}
          />
        ))}
      </Box>
    </>
  );
};

export default LoadingAnimationWithText;
